export const mainNav = [
  { to: '/collectie/voor-haar', label: 'Voor haar' },
  { to: '/collectie/voor-hem', label: 'Voor hem' },
  { to: '/collectie/bestsellers', label: 'Bestsellers' },
  { to: '/collectie/nieuw', label: 'Nieuw' },
  { to: '/collectie/cadeaus', label: 'Cadeaus' },
  { to: '/collectie/alles', label: 'Alle producten' },
]

export const usps = [
  'Vóór 22:00 besteld, morgen in huis',
  'Gratis verzending vanaf € 50',
  '30 dagen bedenktijd',
]
